import InventoryIcon from '@mui/icons-material/Inventory';
import ClothesList from './ClothesList';
import ClothesCreate from './ClothesCreate';
import ClothesEdit from './ClothesEdit';

const resource = {
  list: ClothesList,
  create: ClothesCreate,
  edit: ClothesEdit,
  icon: InventoryIcon,
}
  
export default resource
